import { render, staticRenderFns } from "./BannerLink.vue?vue&type=template&id=5b53d871&scoped=true&"
import script from "./BannerLink.vue?vue&type=script&lang=js&"
export * from "./BannerLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b53d871",
  null
  
)

component.options.__file = "BannerLink.vue"
export default component.exports